export const ADD_TO_CART = 'ADD_TO_CART'
export const ADJUST_ITEM_QUANTITY = 'ADJUST_ITEM_QUANTITY'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const LOAD_CURRENT_ITEM = 'LOAD_CURRENT_ITEM'
export const ADD_TO_FAVORITES = 'ADD_TO_FAVORITES'
export const REMOVE_FROM_FAVORITES = 'REMOVE_FROM_FAVORITES'

//string identifiers